import { Grid } from '@mui/material';

import { FormNumberField, FormTextField } from '../../../../../../common';
import { MEDICAL_NUMERIC_FIELD_BOUNDS } from '../constants';

import type { MedicalFieldsProps } from './types';

export default function ChildDevelopmentFields({
  formik,
  disabled,
  saveFieldOnBlur,
}: MedicalFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began sitting independently at (months)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_sitting_up_age_months.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_sitting_up_age_months.min}
          name="child_sitting_up_age_months"
          onBlur={saveFieldOnBlur}
          placeholder="months"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began crawling at (months)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_crawling_age_months.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_crawling_age_months.min}
          name="child_crawling_age_months"
          onBlur={saveFieldOnBlur}
          placeholder="months"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began walking at (years)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_walking_age_years.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_walking_age_years.min}
          name="child_walking_age_years"
          onBlur={saveFieldOnBlur}
          placeholder="years"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began walking at (months)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_walking_age_months.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_walking_age_months.min}
          name="child_walking_age_months"
          onBlur={saveFieldOnBlur}
          placeholder="months"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began standing independently at (years)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_standing_age_years.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_standing_age_years.min}
          name="child_standing_age_years"
          onBlur={saveFieldOnBlur}
          placeholder="years"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began standing independently at (months)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_standing_age_months.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_standing_age_months.min}
          name="child_standing_age_months"
          onBlur={saveFieldOnBlur}
          placeholder="months"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child began babbling at (months)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_babbling_age_months.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_babbling_age_months.min}
          name="child_babbling_age_months"
          onBlur={saveFieldOnBlur}
          placeholder="months"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Child first word"
          name="child_first_word"
          onBlur={saveFieldOnBlur}
          placeholder="word"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Child second word"
          name="child_second_word"
          onBlur={saveFieldOnBlur}
          placeholder="word"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child first word(s) at (months)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_first_words_age_months.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_first_words_age_months.min}
          name="child_first_words_age_months"
          onBlur={saveFieldOnBlur}
          placeholder="months"
          required
        />
      </Grid>
    </Grid>
  );
}
